/*******************************************************************************
//
//
//
//  #BACKGROUND VIDEO
//
//
//
*******************************************************************************/

var BackgroundVideo = (function () {
    var backgroundVideos = document.querySelectorAll('.c-background-video');

    var _init = function () {
        if(!global.isMobile) {
            for(var i = 0; i < backgroundVideos.length; i++) {
                var sources = backgroundVideos[i].getElementsByTagName('source');

                for(var i = 0; i < sources.length; i++) {
                    var source = sources[i];
                    var video = backgroundVideos[i].getElementsByTagName('video');

                    if(source.dataset.src != undefined) {
                        source.setAttribute('src', source.dataset.src);

                        video[0].load();

                        video[0].addEventListener('canplaythrough', function() {
                            video[0].play();
                        });
                    }
                }
            }
        }
    };

    return {
        init: _init
    };
})();